import { FormControl, styled } from '@mui/material';

export const FormControlStyled = styled(FormControl)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.colors.scrollOnPrimaryBackground}`,
  paddingBottom: '27px',

  '& .MuiFormControlLabel-root': {
    '&:last-of-type': {
      marginBottom: 0,
    },

    '& .MuiSvgIcon-root': {
      width: '14px',
      height: '14px',
    },
  },

  '& .MuiChip-root': {
    marginTop: '24px',

    '& .MuiChip-label': {
      padding: '5px 32px',
      textTransform: 'none',
    },
  },
}));
